import React from "react";

export const IncidentReportDetailContext = React.createContext(null);
export const useIncidentReportDetailContext = () => {
  const context = React.useContext(IncidentReportDetailContext);

  if (!context) throw new Error("Incident Report Detail Context not provided!");

  return context;
};
